import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getExtricationSelector } from '../selectors'
import { ExtricationConstants } from '../store/extrication.constants'
import { IExtricationState } from '../store/extrication.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const extricationState: IExtricationState = yield select(getExtricationSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = extricationState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === ExtricationConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([ExtricationConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
